import { v4 as uuid } from 'uuid'

export default function setupRequstIdInterceptor (axios) {
  axios.interceptors.request.use((config) => {
    config.headers.common['X-OEAMTC-RequestID'] = uuid()
    return config
  })
}
